<template>
  <div class="yuanquxiaoze">
    <van-cell-group>
      <van-cell title="苏州市广济医院" icon="location-o" label="苏州市相城区广前路11号" is-link @click="toPage(1)" />
      <van-cell title="心理咨询中心（平江中心）" icon="location-o" label="苏州人民商场新平江商业广场(人民路3189号)三楼" is-link @click="toPage(2)" />
      <!-- <van-cell title="苏州市家庭教育咨询中心" icon="location-o" label="苏州市姑苏区金太史巷4号" is-link @click="toPage(3)" /> -->
    </van-cell-group>
  </div>
</template>
<script>
import mixin from '../../mixins'
export default {
  name: 'Yuanquxiaoze',
  mixins: [mixin],
  data() {
    return {}
  },
  created() {},
  mounted() {},
  methods: {
    toPage(type) {
      this.$router.push(`/guahaofangshi?type=${type}`)
    }
  }
}
</script>
<style lang="less" scoped></style>
